export * from './src/SmeUserService'
        import * as me from '@peachy/iam-sme-client'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/iam-sme/client'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/iam-sme-client'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    